import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Alert,
} from "reactstrap";
import { ListaPrincipioActivo } from "./ListaPrincipioActivo";
import { Link } from "react-router-dom";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const PrincipioActivoListar = () => {
  document.title = "Lista de Principios Activos | Farme";
  const perfil = DatosSesion("perfil");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardHeader className="border-0">
                      <div className="d-md-flex align-items-center">
                        <h5 className="card-title mb-3 mb-md-0 flex-grow-1">
                          Principios Activos
                        </h5>
                        <div className="flex-shrink-0">
                          <div className="d-flex gap-1 flex-wrap">
                            <Link to="/principiosactivos/crear">
                              <Button
                                color="success"
                                type="button"
                                className="add-btn"
                                data-bs-toggle="modal"
                                id="create-btn"
                                data-bs-target="#showModal"
                              >
                                <i className="ri-add-line align-bottom me-1"></i>{" "}
                                Crear Principio Activo
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <ListaPrincipioActivo />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrincipioActivoListar;
